import { IconPlayerPlay } from "@tabler/icons-react";
import { useCallback, useState } from "react";
import { Modal } from "react-bootstrap";
import useCapture from "~/hooks/useCapture";

type State = {
  isModalShown: boolean;
};

export default function IntroductionVideo() {
  const [state, setState] = useState<State>({ isModalShown: false });
  const capture = useCapture();

  const hideModal = useCallback(() => {
    setState((s) => ({ ...s, isModalShown: false }));
  }, []);

  const showModal = useCallback(() => {
    capture("introductionVideoShown");
    setState((s) => ({ ...s, isModalShown: true }));
  }, [capture]);

  return (
    <>
      <button className="btn btn-lg btn-link gap-4 hstack justify-content-center text-decoration-none" onClick={showModal} type="button">
        <IconPlayerPlay />

        <span>Play product video</span>
      </button>

      <Modal centered onHide={hideModal} show={state.isModalShown} size="xl">
        <Modal.Body>
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video autoPlay className="d-block w-100" controls>
            <source src="https://webgazer-assets.s3.eu-west-1.amazonaws.com/videos/webgazer-intro.mp4" type="video/mp4" />
          </video>
        </Modal.Body>
      </Modal>
    </>
  );
}
